import { ItemService } from '../../_api/services'
import { CREATE_ITEM, FETCH_ITEM, FETCH_ITEMS, UPDATE_ITEM, DELETE_ITEM } from '../actions.type'

const state = {}

const actions = {
  [FETCH_ITEM](context, id) {
    return ItemService.find(id)
  },
  [FETCH_ITEMS]() {
    return ItemService.list()
  },
  [CREATE_ITEM](context, order) {
    return ItemService.create(order)
  },
  [UPDATE_ITEM](context, order) {
    return ItemService.update(order)
  },
  [DELETE_ITEM](context, id) {
    return ItemService.delete(id)
  }
}

export default {
  state,
  actions
}
